import React, { useEffect, useState } from "react";
import { ReactSVG } from "react-svg";
import { useSelector } from "react-redux";
import { Button, notification } from "antd";
import { Link } from "react-router-dom";

import ItemContainer from "../../modules/order/containers/Item";
import withPage from "./withPage";
import UploadForm from "../Forms/Orders/Upload";
import RoutePlanCurrent from "../RoutePlan/RoutePlanCurrent";
import { companyDeactivated, getTranslation } from "../../utils/helper";
import "./OrdersUpload.scss";

const OrdersUploadPage = ({ action, isFetching, status, doUploadOrders, history, query }) => {
  const user = useSelector(state => state.auth.user);
  const setting = user.company;

  // Check company deactivated
  if (companyDeactivated(setting?.status)) {
    notification.error({
      description: "Your account has been deactivated",
      placement: "bottomRight",
    });
    history.push("/orders");
  }

  const [match, setMatch] = useState(false);

  useEffect(() => {
    if (action === "upload" && status === "succeeded") {
      history.push(query.redirectUrl ? query.redirectUrl : "/orders");
    }
  }, [isFetching]);

  const handleNewOrder = async () => {
    const routePlanType = query?.routePlanType || setting?.routePlanType || "PDP";
    const deliveryDate = query?.deliveryDate;
    history.push(`/orders/new?routePlanType=${routePlanType}&deliveryDate=${deliveryDate}`);
  };

  return (
    <div className="Content OrdersUploadPage">
      <RoutePlanCurrent />
      <div className="ContentHeader">
        <div className="HeaderTitle">
          <Link to={"/orders"}>{getTranslation(setting, "Orders", "Orders")}</Link>
          <ReactSVG className="icon" src="/icons/arrow-forward.svg" />
          <span className="Link">{getTranslation(setting, "Orders", "Upload New Orders")}</span>
          {match && (
            <>
              <ReactSVG className="icon" src="/icons/arrow-forward.svg" />
              <span className="Link">{getTranslation(setting, "Orders", "Match Header Data")}</span>
            </>
          )}
        </div>
        <div className="HeaderToolBar">
          <div className="ToolBarButtons">
            <Button size="large" className="NewButton" type="primary" onClick={handleNewOrder}>
              {getTranslation(setting, "Orders", "New Single Order")}
              <ReactSVG className="icon" src="/icons/add.svg" />
            </Button>
          </div>
        </div>
      </div>
      <div className="ContentMain">
        <UploadForm isFetching={isFetching} setMatch={setMatch} doUploadOrders={doUploadOrders} query={query} />
      </div>
    </div>
  );
};

export default withPage(ItemContainer(OrdersUploadPage));
